// App.tsx
import React from 'react';
import { ToastContainer } from 'react-toastify';
import Routers from './Routes';
import { TourProvider } from './context/TourContext';
import { TourLauncher } from './Components/Tour/TourLauncher';
import RegisterStaticSteps from './Components/Tour/RegisterStaticSteps';
import AutoStartTour from './Components/Tour/AutoStartTour'; // below I provide this file
import { BrowserRouter } from 'react-router-dom';

function App() {
  document.body.classList.add("dark-only");
  return (
    <>
      <BrowserRouter basename={'/'}>

        <TourProvider>
          {/* register all static steps */}
          <RegisterStaticSteps />
          {/* AutoStartTour will call startTour() on first-login */}
          <AutoStartTour />
          <TourLauncher />
          <Routers />
          <ToastContainer />
        </TourProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
